/**
 * 定义 webview 右上角功能
 * 目前适用于随手记
 */
import useragent from '@common/useragent'
import domain, { getInstance as domainInstance } from '@common/domain'
// import { absUrl } from '@common/host'
import { call, uriSuishouji } from './bridge'
import { compare } from './version'

/**
 * @param {Object | Array} params
 * {
 *   type: 1, // 0,跳转社区;1,跳转理财;  2,跳转卡牛办卡(iOS已经不支持该跳转协议);  3,跳转贷款;  4,调用分享;  5,调用登陆;  6,回调页面js方法;  7,在当前容器跳转url;  8,刷新页面（安卓V10.6.5.0版本拓展,iOS11.2.9拓展）
 *   title: '菜单按钮显示文字',
 *   url: '跳转url',
 *   image: '按钮 icon 的 url 地址',
 * }
 * or
 * [
 *   { type, title, url, image },
 *   ...
 * ]
 * @param {Function} cb type为6的回调函数
 */
const requestCustomizeMenu = (params = { type: 8, title: '刷新' }, cb) => {
  if (useragent.isSuishouji) {
    const featureVersion = useragent.isIOS ? '11.2.9' : '10.6.5.0'
    if (!compare(featureVersion)) {
      return
    }
    if (Object.prototype.toString.call(params) === '[object Object]') {
      if (params.type === 6) {
        call(uriSuishouji('requestCustomizeMenu', params, 'requestCustomizeMenuCb'), 'requestCustomizeMenuCb', cb, false)
      } else {
        call(uriSuishouji('requestCustomizeMenu', params))
      }
    } else if (Object.prototype.toString.call(params) === '[object Array]') {
      if (params.some(item => item.type === 6)) {
        call(uriSuishouji('requestCustomizeMenu', { items: params }, 'requestCustomizeMenuCb'), 'requestCustomizeMenuCb', cb, false)
      } else {
        call(uriSuishouji('requestCustomizeMenu', { items: params }))
      }
    } else {
      console.warn('参数类型不正确，需要 Object or Array')
    }
  }
}

const env = domainInstance().env
let customerServicePicAddress = ''
if (env !== 'prod') {
  customerServicePicAddress = 'https://lctsres1.ssjlicai.com/public-vue/img/icon-kefu@3x.png'
} else {
  customerServicePicAddress = domain.res + '/public-vue/fixin-product/img/icon-kefu@3x.png'
}

/**
  在线客服
 */
export const customerService = (cb) => {
  requestCustomizeMenu({
    type: 6,
    title: '',
    image: customerServicePicAddress
  }, () => {
    cb && cb()
    window.location.href = 'https://t.feidee.com/customerService'
  })
}

/**
  联系客服
 */
export const contactService = (cb) => {
  requestCustomizeMenu({
    type: 6,
    title: '',
    image: customerServicePicAddress
  }, () => {
    cb && cb()
    window.open('tel:4006988018')
  })
}

/**
  刷新
 */
export const refresh = () => {
  requestCustomizeMenu({
    type: 8,
    title: '',
    image: domain.res + '/public-vue/fixin-product/img/BarButton@3x.png'
  })
}

export default requestCustomizeMenu
